module.exports = __webpack_public_path__ + "rs.f1db11a25fb8d156ff6d.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/rs.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/rs.svg
// module chunks = styles